import Unstructured from './Unstructured.js';
import DataHelper from '../../helpers/DataHelper.js';

export default class VehicleFinanceCalculator extends Unstructured {
  trackInteraction(provider, odometerAnnual, odometerUnit, term, deposit, monthly, currency, type) {
    this._pushEventData(DataHelper.filterDeeply({
      fi_pr: provider,
      fi_ve_od_an: odometerAnnual,
      fi_ve_od_un: odometerUnit,
      fi_te: term,
      fi_de: deposit,
      fi_mo: monthly,
      fi_cu: currency,
      fi_ty: type,
    }));
    this.send();
  }

  _pushEventData(data) {
    super._pushEventData({
      schema: 'iglu:uk.co.netdirector.snowplow/vehicle_finance_calculator_unstructured_event/jsonschema/1-1-0',
      data: data
    });
  }
}
